import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CoreModule } from './@core/core.module';
import {
    NbAccordionModule,
    NbActionsModule,
    NbBadgeModule,
    NbButtonModule,
    NbCardModule,
    NbChatModule,
    NbContextMenuModule,
    NbDialogModule,
    NbIconModule,
    NbInputModule,
    NbLayoutModule,
    NbListModule,
    NbMenuModule,
    NbPopoverModule,
    NbProgressBarModule,
    NbSelectModule,
    NbSidebarModule,
    NbThemeModule,
    NbToastrModule,
    NbTooltipModule,
    NbUserModule,
    NbAutocompleteModule,
    NbTabsetModule,
    
} from '@nebular/theme';
import { ThemeModule } from './@theme/theme.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AUTH_PROVIDERS, AuthService } from './services/auth.service';
import { LoggedInGuard } from './_guards/logged-in.guard';
import { AdminPanelComponent } from './admin-panel/admin-panel.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HeaderComponent } from './header/header.component';
import { HttpClientModule } from '@angular/common/http';
import { SanitizeHtmlPipe } from './sanitize-html.pipe';
import { RefreshTokenComponent } from './refresh-token/refresh-token.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { QuillModule } from 'ngx-quill';
import { EditProfileComponent } from './modals/edit-profile/edit-profile.component';
import { AvatarModule } from 'ngx-avatar';
import { EditInterestsComponent } from './modals/edit-interests/edit-interests.component';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { PersonalComponent } from './modals/personal/personal.component';
import { ViewProfileComponent } from './modals/view-profile/view-profile.component';
import { CustomSocketService } from './services/custom-socket.service';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { AddTutorialComponent } from './modals/add-tutorial/add-tutorial.component';
import { TutorialDetailsComponent } from './modals/tutorial-details/tutorial-details.component';
import { TutorialsListComponent } from './modals/tutorials-list/tutorials-list.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { CreateChatComponent } from './modals/create-chat/create-chat.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { EditTutorialComponent } from './modals/edit-tutorial/edit-tutorial.component';
import { AddWinnersCompetitionComponent } from './modals/add-winners-competition/add-winners-competition.component';
import { SetPasswordComponent } from './auth/set-password/set-password.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
// import { NetworkModule } from './pages/network/network.module';
import { NbOverlayModule } from '@nebular/theme';
import { ViewUsersComponent } from './modals/tutorial-details/view-users/view-users.component';
import { SharedModule } from './shared/shared.module';
import { ImageUploadComponent } from './modals/add-tutorial/image-upload/image-upload.component';
declare module '@angular/core' {
    interface ModuleWithProviders<T = any> {
        ngModule: Type<T>;
        providers?: Provider[];
    }
}

@NgModule({
    declarations: [
        AppComponent,
        CreateChatComponent,
        AdminPanelComponent,
        DashboardComponent,
        HeaderComponent,
        SanitizeHtmlPipe,
        RefreshTokenComponent,
        EditProfileComponent,
        EditInterestsComponent,
        PersonalComponent,
        ViewProfileComponent,
        AddTutorialComponent,
        ImageUploadComponent,
        TutorialDetailsComponent,
        TutorialsListComponent,
        EditTutorialComponent,
        AddWinnersCompetitionComponent,
        ViewUsersComponent,
        
    ],
    imports: [
        NgxDaterangepickerMd.forRoot(),
        BrowserModule,
        NgxPaginationModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        CoreModule.forRoot(),
        HttpClientModule,
        MatBadgeModule,
        MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatListModule,
        MatRadioModule,
        MatSelectModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        MatTooltipModule,
        MatToolbarModule,
        MatSnackBarModule,
        MatDividerModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatButtonToggleModule,
        NbListModule,
        NbButtonModule,
        NbCardModule,
        NbContextMenuModule,
        NbSelectModule,
        NbLayoutModule,
        NbDialogModule.forRoot(),
        NbMenuModule.forRoot(),
        NbSidebarModule.forRoot(),
        NbThemeModule.forRoot(),
        NbToastrModule.forRoot(),
        NbUserModule,
        ThemeModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        NbIconModule,
        AvatarModule,
        NbAccordionModule,
        NbInputModule,
        QuillModule.forRoot(),
        NbChatModule.forRoot(),
        SocketIoModule,
        NbProgressBarModule,
        NbTooltipModule,
        NbBadgeModule,
        NbActionsModule,
        NbAutocompleteModule,
        NbPopoverModule,
        ScrollingModule,
        NbTabsetModule,
        NbOverlayModule,
        SharedModule,
        NgCircleProgressModule.forRoot(),
    ],
    providers: [
        AuthService,
        MatDatepickerModule,
        AUTH_PROVIDERS,
        LoggedInGuard,
        CustomSocketService,
    ],
    // entryComponents: [ForgotPasswordComponent, ],
    entryComponents: [
        RefreshTokenComponent,
        EditProfileComponent,
        EditInterestsComponent,
        PersonalComponent,
        CreateChatComponent,
        ViewUsersComponent,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
